// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"3c64cb3b","726":"fdbd0e65"}[chunkId] + ".chunk.js";
};